import { cn } from '@lib/utils';
import React from 'react';

type SpinnerProps = {
  className?: string;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
};

export const Spinner: React.FC<SpinnerProps> = (props) => {
  const { className = '', size = 'md', color = '#3D2EFF' } = props;

  const sizeMap = {
    sm: { dimensions: 'size-4', thickness: 2 },
    md: { dimensions: 'size-6', thickness: 2 },
    lg: { dimensions: 'size-8', thickness: 3 },
  };

  const { dimensions, thickness } = sizeMap[size];

  return (
    <div className={cn('relative', dimensions, className)}>
      <div
        className="absolute inset-0 rounded-full"
        style={{
          borderWidth: `${thickness}px`,
          borderColor: `${color}20`,
          borderStyle: 'solid',
        }}
      />

      <div
        className="absolute inset-0 rounded-full animate-spin"
        style={{
          borderWidth: `${thickness}px`,
          borderColor: 'transparent',
          borderTopColor: color,
          borderStyle: 'solid',
          animationDuration: '1s',
          animationTimingFunction: 'linear',
        }}
      />
    </div>
  );
};
